import MuiLink from '@mui/material/Link';
import { LinkProps } from './interface';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

/**
 *
 * this component is not ready for use in production yet. it is one that will be done soon
 */
export const Link = ({ to, external, ...rest }: LinkProps) =>
  to ? (
    <MuiLink
      component={ReactRouterLink}
      to={to}
      {...rest}
      sx={{ '&:hover': { textDecoration: 'none' } }}
    />
  ) : (
    <MuiLink
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      {...rest}
    />
  );
